import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { config } from 'rxjs';
import { MatDialog } from '@angular/material';
/* import { CustomescriptComponent } from '../customescript/customescript.component.js'; */
import { CustomvariableComponent } from '../scripteditor/customvariable/customvariable.component.js';
declare var CKEDITOR: any;
@Component({
  selector: 'app-ckninjaeditor',
  templateUrl: './ckninjaeditor.component.html',
  styleUrls: ['./ckninjaeditor.component.css']
})
export class CkninjaeditorComponent implements OnInit {
  public leadValue:any;  
  constructor(public dialog: MatDialog) { }
  @Output() public editorscript = new EventEmitter<any>();
  @Input() public editscripteditor:string;
  ngOnInit() {
     console.log(this.editscripteditor);
  }

  validateChange(event:any)
  {
    if(event!==null && event!==undefined)
    {
      console.log(event);
      this.editorscript.emit(event);
    }
     
  }

  onclickMenu()
  {
    const dialogRef = this.dialog.open(CustomvariableComponent, {
      disableClose: true,
      width: '770px', data:{}
    });
    dialogRef.afterClosed().subscribe(result => {
       console.log(result.leadType);
       if(result!=null && result!=undefined){
        for(var i in CKEDITOR.instances) {
          this.leadValue= CKEDITOR.instances[i].insertText('{'+result.leadType.toUpperCase()+'}');
          }
        }
     }); 
  }


 /*  onSomeAction() 
  {
     var z = document.createElement('p'); 
    z.innerHTML = 'test satu dua tiga';
     console.log(this.myckeditor.instance.getData()); 
     let ranges = this.myckeditor.instance.getSelection().getRanges()[0];
     let setval= ranges.setData("str");
     console.log(setval);
    CKEDITOR.instances['editor1'].setData("str");

    for(var i in CKEDITOR.instances) {
      CKEDITOR.instances[i].insertText("myValue");
  }
     } */

}